import {FormikValues} from 'formik';
import {SIDEBAR_TYPES} from '../const';

export const getValuesForTypes = (data: Record<string, any>, type:number,count: number):any => {
  if(type === SIDEBAR_TYPES.WAVE || type === SIDEBAR_TYPES.PIPE){
    return (Math.trunc(data.price) * count).toLocaleString()
  }
  return ''
}

export const priceInfoDepositPayHere = (data: Record<string, any> | null, count: number, stock: number) => {
  return{
    price: data ? 1+(Number(data.price) * count) : 0,
    stock: data ? Number(stock) : 0,
    price_total: data ?  (Number(data.price) * count - Number(stock)) : 0,
    minutes:  data ? Number(data.minutes) * count : 0,
    count_people:  data ? Number(data.count_people) * count : 0
  }
}

export const checkFlagBtnPay = (arr: Array<any>, values: Record<string, any>, total_price: number) => {
  let count = 0;
  if(arr.length !== 0) {
    arr.forEach((item: Record<string, any>)=>{
      count += Number(values[item.name])
    })
  }
  return ( count === total_price)
}

export const priceInfo = (formik: FormikValues, count: number) => {
 return {
   price: Number(formik.values.base_price),
   price_stock: Number(formik.values.price_stock * count),
   price_total: Number(formik.values.base_price) * count  - Number(formik.values.price_stock * count),
   resource: Number(formik.values.resource),
 }
}